import { render, staticRenderFns } from "./share-settings-modal.vue?vue&type=template&id=10e446e2&"
import script from "./share-settings-modal.vue?vue&type=script&lang=js&"
export * from "./share-settings-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports